import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bcf9c4a4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bcf9c4a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf9c4a4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CourseAutocomplete: require('/builds/marketing/abstracta.academy-website/components/CourseAutocomplete.vue').default,HeaderMain: require('/builds/marketing/abstracta.academy-website/components/HeaderMain.vue').default})
